// extracted by mini-css-extract-plugin
export default {"policy":"policy_policy__SLDWI","priceTable":"policy_priceTable__dgMnf"};